import { BuzerIcon } from "../../../BuzerIcons";

// Form / field-group caption — the mono-uppercase label above filter groups, spec
// blocks and field rows. Same type as SectionHeader's label (so captions and
// section dividers read as one system) but WITHOUT the hairline rule: captions sit
// inside forms/cards where a full-width rule would be too heavy. `icon` adds a
// leading glyph for field-row labels.
//
// variant (v29):
//   "label" (default) — pôvodné mono-verzálky (menovka nad skupinou polí)
//   "note"            — vysvetľujúca VETA pod obsahom (bez verzálok a prestrkania,
//                       zalamuje sa cez viac riadkov). Vzniklo pre §7.3 „Séria ×1,2 —
//                       základ 10 b…", kde by verzálky kričali a na 360 px sa nezmestili.
const base = {
  fontFamily: "var(--ff-ui)", fontSize: 10, fontWeight: 600, letterSpacing: ".14em",
  color: "var(--neutral-text-subtle)", textTransform: "uppercase",
  display: "inline-flex", alignItems: "center", gap: 5,
};

const note = {
  fontFamily: "var(--ff-ui)", fontSize: 12, fontWeight: 400, letterSpacing: 0,
  color: "var(--neutral-text-muted)", textTransform: "none", lineHeight: 1.45,
  display: "flex", alignItems: "flex-start", gap: 5,
};

export function Caption({ children, icon, variant = "label", style }) {
  const v = variant === "note" ? note : base;
  return (
    <span style={{ ...v, ...style }}>
      {icon && <BuzerIcon name={icon} size={12} color="currentColor" />}
      {children}
    </span>
  );
}
